export default __webpack_public_path__ + "static/media/iPhoneX1-installer.3ca3f5d9.png";